import React, { useEffect, useState } from 'react'
import { getCookie } from 'typescript-cookie'
import { Buffer } from 'buffer'

const isJWT = (token: string) => {
  const parts = token.split('.')
  return parts.length === 3
}

export const useToken = (source: 'db' | 'cookie' = 'cookie',
  refresh: any = undefined,
  delay = 100) => {
  const [token, setToken] = useState({
    data: undefined,
    error: undefined
  })

  const getTokenFromIndexDB = () => {
    const getTokenData = (arr: any) => {
      const obj = {
        data: undefined,
        error: undefined
      }

      try {
        obj.data = undefined
        if (arr.length !== 0) {
          try {
            const infoObj = arr.find(item => item.fbase_key)
            if (infoObj !== undefined) {
              const info = infoObj.value.stsTokenManager
              if (info === undefined) {
                obj.error = {
                  message: 'Authentication failed. Unable to read the Token.'
                }
              } else {
                obj.data = info
              }
            } else {
              obj.error = {
                message: 'Authentication failed. Unable to find the Token.'
              }
            }
          } catch (e) {
            obj.error = {
              message: e.message
            }
          }
        } else {
          obj.error = {
            message: 'Authentication failed.'
          }
        }
      } catch (err) {
        obj.data = undefined
        obj.error = {
          message: err.message
        }
      }
      return obj
    }

    const request = indexedDB.open('firebaseLocalStorageDb', 1)

    request.onsuccess = e => {
      //@ts-ignore
      const db = e.target.result
      console.log(`Success: ${db.name} ${db.version}`)
      try {
        const tx = db.transaction('firebaseLocalStorage', 'readonly')
        const data = tx.objectStore('firebaseLocalStorage')
        const req = data.getAll()

        req.onsuccess = e => {
          const res = e.target.result
          if (res) {
            setToken(getTokenData(res))
          }
        }
      } catch (error) {
        console.log(`Error: ${error}`)
      }
    }

    request.onerror = e => {
      //@ts-ignore
      const error = e.target.error
      console.log(`Error: ${error}`)
    }
  }

  const getTokenFromCookie = () => {
    const value = getCookie('pollination-authz')
    if (value) {
      const base64string = value.replace(/_/g, '/').replace(/-/g, '+')
      const buffer = Buffer.from(base64string, 'base64')
      if (buffer) {
        const innerBase64 = buffer.toString('utf-8')?.split('|')[1]
        if (!innerBase64) return
        const token = Buffer.from(innerBase64, 'base64')?.toString('utf-8')

        if (!isJWT(token)) {
          setToken({
            data: undefined,
            error: {
              message: 'Authentication failed. The pollination-authz cookie does not contain a JWT token. Try the useAPIKey hook instead.'
            }
          })
          return
        }

        setToken({
          data: token,
          error: undefined
        })
      }
    }
  }

  useEffect(() => {
    const fnc = (source === 'db') ? getTokenFromIndexDB : getTokenFromCookie
    const handler = setTimeout(fnc, delay)
    return () => clearTimeout(handler)
  }, [refresh, delay, source])

  return token
}